import { render, staticRenderFns } from "./MEvaluationBibliographicResource.vue?vue&type=template&id=46eaefd8&scoped=true"
import script from "./MEvaluationBibliographicResource.vue?vue&type=script&lang=js"
export * from "./MEvaluationBibliographicResource.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=46eaefd8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eaefd8",
  null
  
)

export default component.exports